import { render } from "./request-details.vue?vue&type=template&id=49059aa2&scoped=true"
import script from "./request-details.vue?vue&type=script&lang=js"
export * from "./request-details.vue?vue&type=script&lang=js"

import "./request-details.vue?vue&type=style&index=0&id=49059aa2&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49059aa2"]])

export default __exports__